var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LockLoader',{attrs:{"text":"Carregando seu pedido no Parcelex"}})
}
var staticRenderFns = []

export { render, staticRenderFns }